import { FC } from 'react'

import { TagsNoRef } from '@trustycars/genie-ui/types'
import { propsWithClassNames } from '@trustycars/genie-ui/functions'
import { svg } from '@trustycars/genie-ui/icons/Icon/style.css'

import { getIcon } from './functions'
import { SIZE, Namespaces } from './constants'

export type ExtraIconProps = {
  name: Namespaces
} & TagsNoRef<'svg'>

export const ExtraIcon: FC<ExtraIconProps> = ({ name, ...props }) => (
  <svg width={SIZE} height={SIZE} {...propsWithClassNames(props, svg)}>
    <use xlinkHref={`#${getIcon(name)}`} />
  </svg>
)

export default ExtraIcon
